import { clearPrefetches, defineNuxtPlugin, prefetchRoute, recordAccessTokenAtRender, useCoreLogger, useRouter } from '#imports'

// The browser prefetches in `00.prefetch.global`: a router guard added here would run after middleware.
export default defineNuxtPlugin({
    name: 'core:prefetch',
    enforce: 'post',
    setup(nuxtApp) {
        // A held request is stale once the page it was for has rendered.
        const finish = () => {
            const untaken = clearPrefetches(nuxtApp)

            // A declaration that drifted from its page's queries.
            if (import.meta.dev && untaken.length) {
                nuxtApp.runWithContext(() => useCoreLogger().withTag('prefetch').warn('no query took over', untaken))
            }
        }

        if (import.meta.client) {
            nuxtApp.hook('page:finish', finish)
            return
        }

        nuxtApp.hook('app:rendered', finish)
        // A render that throws ends without app:rendered.
        nuxtApp.hook('app:error', finish)

        const accessTokenFresh = recordAccessTokenAtRender() === 'fresh'

        prefetchRoute(useRouter().resolve(nuxtApp.ssrContext!.url), { accessTokenFresh })
    },
})
